import {MemoryFeedField} from '@/pages/feeds/Editor/Mapper/index.tsx';
import {Button, Size, Tooltip} from '@blueprintjs/core';
import {ReactElement, useCallback} from 'react';

interface ControlsProps {
	field: MemoryFeedField,
	onDelete: (field: MemoryFeedField) => void,
	onShowMapping: (field: MemoryFeedField) => void,
}

export function Controls({field, onDelete, onShowMapping}: ControlsProps): ReactElement {
	const onDeleteClick = useCallback(() => {
		onDelete(field);
	}, [field, onDelete]);

	const onShowMappingClick = useCallback(() => {
		onShowMapping(field);
	}, [field, onShowMapping]);

	return (
		<div style={{display: 'flex', gap: 10, justifyContent: 'end'}}>
			<Tooltip content="Field Manipulation">
				<Button variant="minimal" icon="data-lineage" size={Size.SMALL} onClick={onShowMappingClick} />
			</Tooltip>

			<Tooltip content="Delete" intent="warning">
				<Button variant="minimal" icon="delete" intent="danger" onClick={onDeleteClick} size={Size.SMALL} />
			</Tooltip>
		</div>
	);
}
